<template>
  <DefaultLayout no-lang>
    <FloatingBox class="sm:w-auto relative overflow-hidden">
      <span v-if="failed" class="text-red-700">{{$t('barcode.failed')}}</span>
      <div v-else class="barcode text-center">
        <div v-if="collected" class="mb-4 text-xl text-red-700 font-bold">{{$t('barcode.already-collected')}}</div>
        <div v-else-if="location" class="mb-4 text-xl">{{$t('barcode.collect-at')}} <strong>{{location}}</strong></div>
        <img :src="url" :alt="barcode" @error="error">
        <div class="mt-4 text-lg">{{barcode}}</div>
      </div>
      
    </FloatingBox>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '../layouts/Default.vue'
import FloatingBox from '../components/FloatingBox'
import api from '../api';

export default {
  name: 'Search',
  components: {
    DefaultLayout,
    FloatingBox,
  },
  props: {
    barcode: String
  },
  data() {
    return {
      failed: false,
      collected: false,
      location: null,
    }
  },
  computed: {
    url() {
        return process.env.VUE_APP_API_HOST + `barcode/${this.barcode}`
    }
  },
  async created() {
      const {data: {collected, location}} = await api.get(`barcode-info/${this.$route.params.barcode}`)
      this.collected = collected
      this.location = location
  },
  methods: {
    error() {
      this.failed = true
    }
  },
  metaInfo() {
    return {
      title: this.$t('barcode.title'),
    }
  } 
};
</script>

<style lang="scss" scoped>
  .barcode {
    width: 500px;

    img {
      width: 100%;
    }

    @media(max-width: 640px) {
      @media(orientation: portrait) {
        position:absolute;
        transform: rotate(90deg);
        max-width: 75vh;
        width: 75vh;
        top: 35%;
        margin-left: -37.5vh;
        left: 50%;
      }

      @media(orientation: landscape) {
        width: 100%;
      }
    }
  }
</style>